const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

const BASE = API_URL + '/api/index'

/* ───── Tipler ───── */

export interface IndexQuote {
  symbol: string
  name: string
  price: number
  open: number
  high: number
  low: number
  previousClose: number
  change: number
  changePercent: number
  week52High: number
  week52Low: number
  lastUpdate: number
}

export interface IndexChartPoint {
  time: number
  value: number
}

export interface OhlcvPoint {
  time: string
  open: number
  high: number
  low: number
  close: number
  volume: number | null
}

export interface OhlcvChartData {
  symbol: string
  count: number
  data: OhlcvPoint[]
}

export interface IndexPeriodChange {
  monthly: number
  yearly: number
}

/* ───── Quote (Fiyat) Servisi ───── */

export async function fetchIndexQuotes(symbols: string[]): Promise<Record<string, IndexQuote>> {
  try {
    const res = await fetch(`${BASE}/quotes?symbols=${symbols.join(',')}`)
    if (!res.ok) return {}
    return await res.json()
  } catch {
    return {}
  }
}

/* ───── Tarihsel Veri (Grafik) Servisi ───── */

export async function fetchIndexChartData(
  symbol: string,
  period: string,
): Promise<IndexChartPoint[]> {
  try {
    const res = await fetch(`${BASE}/chart?symbol=${encodeURIComponent(symbol)}&period=${period}`)
    if (!res.ok) return []
    return await res.json()
  } catch {
    return []
  }
}

/* ───── OHLCV Grafik Verisi ───── */

export async function fetchIndexOhlcvData(
  symbol: string,
  period: string,
): Promise<OhlcvChartData | null> {
  try {
    const res = await fetch(`${BASE}/chart?symbol=${encodeURIComponent(symbol)}&period=${period}`)
    if (!res.ok) return null
    return await res.json()
  } catch {
    return null
  }
}

/* ───── Endeks Bileşen Hisseleri (Pagination) ───── */

export interface ConstituentStock {
  symbol: string
  name: string
  weight: number | null
  price: number
  change: number
  changePercent: number
  high: number
  low: number
  volume: number
  monthly: number | null
  yearly: number | null
}

export interface ConstituentsResponse {
  items: ConstituentStock[]
  totalCount: number
  page: number
  pageSize: number
}

export async function fetchIndexConstituents(
  symbol: string,
  page = 1,
  pageSize = 20,
  search?: string,
): Promise<ConstituentsResponse> {
  try {
    let url = `${BASE}/constituents?symbol=${encodeURIComponent(symbol)}&page=${page}&pageSize=${pageSize}`
    if (search) url += `&search=${encodeURIComponent(search)}`
    const res = await fetch(url)
    if (!res.ok) return { items: [], totalCount: 0, page, pageSize }
    return await res.json()
  } catch {
    return { items: [], totalCount: 0, page, pageSize }
  }
}

/* ───── Aylık / Yıllık Değişim ───── */

export async function fetchIndexPeriodChanges(
  symbols: string[],
): Promise<Record<string, IndexPeriodChange>> {
  try {
    const res = await fetch(`${BASE}/period-changes?symbols=${symbols.join(',')}`)
    if (!res.ok) return {}
    return await res.json()
  } catch {
    return {}
  }
}
